import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/commission-plans/new/loading';

export const Route = createFileRoute('/_private/settings/commission-plans/new')({
  component: Loading,
});
